// Mind2Magic CRM — Empresas (B2B) Module
// Extracted from index.html Step 10.

import { EMPRESAS_STAGES } from './constants.js'
import { store } from './store.js'

let empIsDragging = false
let empDragStartX = 0, empDragStartY = 0
let empSelectionBox = null

function switchCrmMode(mode) {
    const { crmMode } = store
    if (crmMode === mode) return
    store.crmMode = mode
    document.querySelectorAll('.mode-btn').forEach(btn => btn.classList.toggle('active', btn.dataset.mode === mode))
    document.querySelectorAll('.nav-turismo').forEach(el => el.style.display = mode === 'turismo' ? '' : 'none')
    document.querySelectorAll('.nav-empresas').forEach(el => el.style.display = mode === 'empresas' ? '' : 'none')
    if (mode === 'empresas') {
        window.showView('empPipeline')
        populateEmpCompanyDropdowns()
        renderEmpPipeline()
        renderEmpCompanies()
    } else {
        window.showView('pipeline')
    }
}

function populateEmpCompanyDropdowns() {
    const { companies } = store
    const opts = '<option value="">Todas</option>' + companies.filter(c => c.active !== false).map(c => `<option value="${c.id}">${c.name}</option>`).join('')
    const selIds = ['empFilterCompany', 'invoiceCompany']
    selIds.forEach(id => { const el = document.getElementById(id); if (el) el.innerHTML = opts })
}

function getFilteredBookings() {
    const { companyBookings } = store
    let filtered = [...companyBookings]
    const compId = document.getElementById('empFilterCompany')?.value
    const month = document.getElementById('empFilterMonth')?.value
    const year = document.getElementById('empFilterYear')?.value
    const stage = document.getElementById('empFilterStage')?.value
    const sort = document.getElementById('empFilterSort')?.value
    if (compId) filtered = filtered.filter(b => b.companyId === compId)
    if (stage) filtered = filtered.filter(b => b.stage === stage)
    if (month || year) {
        filtered = filtered.filter(b => {
            if (!b.checkIn) return false
            const d = new Date(b.checkIn)
            if (month && (d.getMonth() + 1) !== parseInt(month)) return false
            if (year && d.getFullYear() !== parseInt(year)) return false
            return true
        })
    }
    // Sort
    if (sort) {
        filtered.sort((a, b) => {
            switch (sort) {
                case 'checkin_asc': return (a.checkIn || '').localeCompare(b.checkIn || '')
                case 'checkin_desc': return (b.checkIn || '').localeCompare(a.checkIn || '')
                case 'nombre_asc': return (a.travelerName || '').localeCompare(b.travelerName || '')
                case 'nombre_desc': return (b.travelerName || '').localeCompare(a.travelerName || '')
                case 'total_asc': return (a.totalPurchase || 0) - (b.totalPurchase || 0)
                case 'total_desc': return (b.totalPurchase || 0) - (a.totalPurchase || 0)
                case 'comm_asc': return (a.commissionAmount || 0) - (b.commissionAmount || 0)
                case 'comm_desc': return (b.commissionAmount || 0) - (a.commissionAmount || 0)
                default: return 0
            }
        })
    }
    return filtered
}

function resetEmpFilters() {
    ['empFilterCompany', 'empFilterMonth', 'empFilterYear', 'empFilterStage'].forEach(id => {
        const el = document.getElementById(id)
        if (el) el.value = ''
    })
    const sortEl = document.getElementById('empFilterSort')
    if (sortEl) sortEl.value = 'checkin_asc'
    renderEmpPipeline()
}

function populateEmpYearFilters() {
    const { companyBookings } = store
    const years = new Set()
    companyBookings.forEach(b => {
        if (b.checkIn) { const y = new Date(b.checkIn).getFullYear(); if (y > 2000) years.add(y) }
        if (b.checkOut) { const y = new Date(b.checkOut).getFullYear(); if (y > 2000) years.add(y) }
    })
    const sorted = [...years].sort((a, b) => b - a)
    const opts = '<option value="">Todos</option>' + sorted.map(y => `<option value="${y}">${y}</option>`).join('')
    ;['empFilterYear', 'invoiceYear'].forEach(id => {
        const el = document.getElementById(id)
        if (el) el.innerHTML = opts
    })
}


function renderEmpPipeline() {
    const { companyBookings, empSelectionMode } = store
    const el = document.getElementById('empPipelineKanban')
    if (!el) return
    const filtered = getFilteredBookings()

    el.innerHTML = EMPRESAS_STAGES.map(s => {
        const stageBookings = filtered.filter(b => b.stage === s.id)
        const stageTotal = stageBookings.reduce((sum, b) => sum + (b.m2mAmount || 0), 0)
        const selectBtn = empSelectionMode && stageBookings.length ? `<button class="col-select-btn" onclick="event.stopPropagation(); selectEmpColumn('${s.id}')" title="Seleccionar columna">☑</button>` : ''
        return `<div class="column" data-emp-stage="${s.id}">
            <div class="col-header">
                <div class="col-title"><span class="col-dot" style="background:${s.color}"></span>${s.name}</div>
                <div style="display:flex;align-items:center;gap:6px;">
                    <span style="font-size:10px;color:var(--text-3);">${window.fmtUSD(stageTotal)}</span>
                    ${selectBtn}
                    <span class="col-count">${stageBookings.length}</span>
                </div>
            </div>
            <div class="col-cards" data-emp-stage="${s.id}">
                ${stageBookings.length ? stageBookings.map(renderBookingCard).join('') : '<div class="col-empty">Sin reservas</div>'}
            </div>
        </div>`
    }).join('')

    setupEmpDragDrop()
    if (empSelectionMode) setupEmpSelectionMode()
    updateEmpStats(filtered)
    document.getElementById('badgeEmpBookings').textContent = companyBookings.length
    // Restaurar leads zoom
    window.setLeadsZoom(window._currentLeadsZoom || 1)
}

function renderBookingCard(b) {
    const { companies, empSelectionMode } = store
    const company = companies.find(c => c.id === b.companyId)
    const companyName = company?.name || 'Sin empresa'
    return `<div class="card emp-card" draggable="${!empSelectionMode}" data-booking-id="${b.id}" onclick="openBookingDetail('${b.id}')">
        <div class="card-top">
            <div style="display:flex;align-items:center;gap:6px;"><div>
                <div class="card-name">${b.travelerName || 'Sin nombre'}</div>
                <div style="font-size:10px;color:var(--text-3);">${companyName}</div>
            </div></div>
        </div>
        <div class="card-info">
            ${b.hotelName ? `<div class="card-row" style="font-size:11px;color:var(--text-2);">${b.hotelName.length > 30 ? b.hotelName.substring(0, 30) + '...' : b.hotelName}</div>` : ''}
            <div class="card-row" style="font-size:11px;">
                <span style="color:var(--text-2);">${b.destination || ''}</span>
                <span style="color:var(--text-3);margin-left:6px;">${b.checkIn ? new Date(b.checkIn + 'T12:00:00').toLocaleDateString('es-CO', { month: 'short', day: 'numeric' }) : ''}</span>
            </div>
        </div>
        <div class="card-financials" style="display:flex;justify-content:space-around;padding:8px 0;border-top:1px solid var(--border);margin-top:6px;">
            <div style="text-align:center;"><div style="font-size:13px;font-weight:700;color:var(--blue);">${window.fmtUSD(b.totalPurchase)}</div><div style="font-size:9px;color:var(--text-3);">Compra</div></div>
            <div style="text-align:center;"><div style="font-size:13px;font-weight:700;color:var(--yellow);">${window.fmtUSD(b.commissionAmount)}</div><div style="font-size:9px;color:var(--text-3);">Comisión</div></div>
            <div style="text-align:center;"><div style="font-size:13px;font-weight:700;color:var(--green);">${window.fmtUSD(b.m2mAmount)}</div><div style="font-size:9px;color:var(--text-3);">M2M</div></div>
        </div>
    </div>`
}

function setupEmpDragDrop() {
    const { companyBookings } = store
    document.querySelectorAll('.emp-card[draggable="true"]').forEach(card => {
        card.ondragstart = e => { card.classList.add('dragging'); e.dataTransfer.setData('text', card.dataset.bookingId) }
        card.ondragend = () => { card.classList.remove('dragging'); document.querySelectorAll('[data-emp-stage]').forEach(c => c.classList.remove('drag-over')) }
    })
    document.querySelectorAll('.column[data-emp-stage]').forEach(col => {
        const stageId = col.dataset.empStage
        col.ondragover = e => { e.preventDefault(); col.classList.add('drag-over') }
        col.ondragleave = () => col.classList.remove('drag-over')
        col.ondrop = e => {
            e.preventDefault(); col.classList.remove('drag-over')
            const id = e.dataTransfer.getData('text')
            const booking = companyBookings.find(b => b.id === id)
            if (booking && booking.stage !== stageId) {
                booking.stage = stageId
                window.supabaseDB.updateBookingStage(id, stageId)
                renderEmpPipeline()
                window.toast(`Reserva movida a "${EMPRESAS_STAGES.find(s => s.id === stageId)?.name || stageId}"`, 'success')
            }
        }
    })
}

function updateEmpStats(filtered) {
    const total = filtered.reduce((s, b) => s + (b.totalPurchase || 0), 0)
    const comm = filtered.reduce((s, b) => s + (b.commissionAmount || 0), 0)
    const m2m = filtered.reduce((s, b) => s + (b.m2mAmount || 0), 0)
    const el = id => document.getElementById(id)
    if (el('empStatBookings')) el('empStatBookings').textContent = filtered.length
    if (el('empStatTotal')) el('empStatTotal').textContent = window.fmtUSD(total)
    if (el('empStatComm')) el('empStatComm').textContent = window.fmtUSD(comm)
    if (el('empStatM2M')) el('empStatM2M').textContent = window.fmtUSD(m2m)
}

// --- EMPRESAS SELECTION MODE (mirrors turismo) ---

function toggleEmpSelectMode() {
    const { empSelectionMode } = store
    store.empSelectionMode = !empSelectionMode
    if (store.empSelectionMode) {
        document.getElementById('btnEmpSelect').textContent = '☑ Todo'
        document.getElementById('btnEmpSelect').classList.add('active')
        ;['empSelectedCount', 'empBulkStage', 'btnEmpExport', 'btnEmpCancelSelect'].forEach(id => {
            document.getElementById(id).style.display = ''
        })
        renderEmpPipeline() // Re-render to show column select buttons
    } else {
        // Second click = select all visible
        selectAllEmpVisible()
    }
    updateEmpSelectionCount()
}

function setupEmpSelectionMode() {
    const pipeline = document.getElementById('empPipelineKanban')
    if (pipeline) pipeline.classList.add('selecting')

    document.querySelectorAll('.emp-card').forEach(card => {
        card.classList.add('selectable')
        card.draggable = false
        const id = card.dataset.bookingId
        card.onclick = (e) => { e.stopPropagation(); toggleEmpBooking(id) }
    })
    setupEmpDragSelection()
}

function setupEmpDragSelection() {
    const pipeline = document.getElementById('empPipelineKanban')
    if (!pipeline) return
    pipeline.removeEventListener('mousedown', startEmpDragSelection)
    document.removeEventListener('mousemove', updateEmpDragSelection)
    document.removeEventListener('mouseup', endEmpDragSelection)
    pipeline.addEventListener('mousedown', startEmpDragSelection)
    document.addEventListener('mousemove', updateEmpDragSelection)
    document.addEventListener('mouseup', endEmpDragSelection)
}

function startEmpDragSelection(e) {
    const { empSelectionMode, empSelectedBookings } = store
    if (!empSelectionMode) return
    if (e.target.closest('button')) return
    e.preventDefault()
    empIsDragging = true
    empDragStartX = e.clientX
    empDragStartY = e.clientY
    const card = e.target.closest('.emp-card')
    if (card) {
        empSelectedBookings.add(card.dataset.bookingId)
        card.classList.add('selected')
        updateEmpSelectionCount()
    }
    empSelectionBox = document.createElement('div')
    empSelectionBox.className = 'selection-box'
    document.body.appendChild(empSelectionBox)
}

function updateEmpDragSelection(e) {
    const { empSelectedBookings } = store
    if (!empIsDragging || !empSelectionBox) return
    e.preventDefault()
    const x = Math.min(e.clientX, empDragStartX)
    const y = Math.min(e.clientY, empDragStartY)
    const w = Math.abs(e.clientX - empDragStartX)
    const h = Math.abs(e.clientY - empDragStartY)
    empSelectionBox.style.left = x + 'px'
    empSelectionBox.style.top = y + 'px'
    empSelectionBox.style.width = w + 'px'
    empSelectionBox.style.height = h + 'px'
    const boxRect = { left: x, top: y, right: x + w, bottom: y + h }
    document.querySelectorAll('.emp-card.selectable').forEach(card => {
        const cardRect = card.getBoundingClientRect()
        const intersects = !(cardRect.right < boxRect.left || cardRect.left > boxRect.right || cardRect.bottom < boxRect.top || cardRect.top > boxRect.bottom)
        if (intersects) {
            empSelectedBookings.add(card.dataset.bookingId)
            card.classList.add('selected')
        }
    })
    updateEmpSelectionCount()
}

function endEmpDragSelection() {
    if (empSelectionBox) { empSelectionBox.remove(); empSelectionBox = null }
    empIsDragging = false
}

function selectAllEmpVisible() {
    const { empSelectedBookings } = store
    document.querySelectorAll('.emp-card.selectable').forEach(card => {
        empSelectedBookings.add(card.dataset.bookingId)
        card.classList.add('selected')
    })
    updateEmpSelectionCount()
}

function selectEmpColumn(stageId) {
    const { empSelectedBookings } = store
    const column = document.querySelector(`.col-cards[data-emp-stage="${stageId}"]`)
    if (!column) return
    column.querySelectorAll('.emp-card').forEach(card => {
        empSelectedBookings.add(card.dataset.bookingId)
        card.classList.add('selected')
    })
    updateEmpSelectionCount()
}

function toggleEmpBooking(id) {
    const { empSelectedBookings } = store
    const card = document.querySelector(`.emp-card[data-booking-id="${id}"]`)
    if (empSelectedBookings.has(id)) {
        empSelectedBookings.delete(id)
        card?.classList.remove('selected')
    } else {
        empSelectedBookings.add(id)
        card?.classList.add('selected')
    }
    updateEmpSelectionCount()
}

function updateEmpSelectionCount() {
    const { empSelectedBookings } = store
    document.getElementById('empSelectedCount').textContent = empSelectedBookings.size + ' seleccionados'
}

function cancelEmpSelection() {
    const { empSelectedBookings } = store
    store.empSelectionMode = false
    empSelectedBookings.clear()
    empIsDragging = false
    if (empSelectionBox) { empSelectionBox.remove(); empSelectionBox = null }

    const pipeline = document.getElementById('empPipelineKanban')
    if (pipeline) pipeline.classList.remove('selecting')

    document.getElementById('btnEmpSelect').textContent = '☑ Seleccionar'
    document.getElementById('btnEmpSelect').classList.remove('active')
    ;['empSelectedCount', 'empBulkStage', 'btnEmpExport', 'btnEmpCancelSelect'].forEach(id => {
        document.getElementById(id).style.display = 'none'
    })
    const stageSelect = document.getElementById('empBulkStage')
    if (stageSelect) stageSelect.value = ''
    document.querySelectorAll('.emp-card').forEach(card => {
        card.classList.remove('selectable', 'selected')
        const bid = card.dataset.bookingId
        card.onclick = () => window.openBookingDetail(bid)
    })
    renderEmpPipeline()
}

function empBulkSetStage(stage) {
    const { companyBookings, empSelectedBookings } = store
    if (!stage) return
    if (empSelectedBookings.size === 0) { window.toast('Selecciona al menos una reserva', 'warning'); return }
    const count = empSelectedBookings.size
    empSelectedBookings.forEach(id => {
        const b = companyBookings.find(bk => bk.id === id)
        if (b) { b.stage = stage; window.supabaseDB.updateBookingStage(id, stage) }
    })
    cancelEmpSelection()
    window.toast(`${count} reservas marcadas como ${EMPRESAS_STAGES.find(s => s.id === stage)?.name || stage}`, 'success')
}

function empExportSelected() {
    const { companyBookings, empSelectedBookings } = store
    const selected = companyBookings.filter(b => empSelectedBookings.has(b.id))
    if (!selected.length) { window.toast('Selecciona al menos una reserva', 'warning'); return }
    exportBookingsToExcel(selected, 'Seleccion')
}

// --- COMPANY CRUD ---
function openNewCompanyModal() {
    document.getElementById('compEditId').value = ''
    document.getElementById('compModalTitle').textContent = 'Nueva Empresa'
    document.getElementById('compName').value = ''
    document.getElementById('compContactName').value = ''
    document.getElementById('compContactEmail').value = ''
    document.getElementById('compContactPhone').value = ''
    document.getElementById('compCommPct').value = '8.5'
    document.getElementById('compNotes').value = ''
    window.openModal('newCompanyModal')
}

function openEditCompany(id) {
    const { companies } = store
    const c = companies.find(co => co.id === id)
    if (!c) return
    document.getElementById('compEditId').value = id
    document.getElementById('compModalTitle').textContent = 'Editar Empresa'
    document.getElementById('compName').value = c.name || ''
    document.getElementById('compContactName').value = c.contactName || ''
    document.getElementById('compContactEmail').value = c.contactEmail || ''
    document.getElementById('compContactPhone').value = c.contactPhone || ''
    document.getElementById('compCommPct').value = c.defaultCommissionPct || 8.5
    document.getElementById('compNotes').value = c.notes || ''
    window.openModal('newCompanyModal')
}

function saveCompany() {
    const { companies } = store
    const name = document.getElementById('compName').value.trim()
    if (!name) { window.toast('Nombre requerido', 'error'); return }
    const editId = document.getElementById('compEditId').value
    let company
    if (editId) {
        company = companies.find(c => c.id === editId)
        if (!company) return
    } else {
        company = { id: 'comp_' + Date.now(), active: true }
        companies.push(company)
    }
    company.name = name
    company.contactName = document.getElementById('compContactName').value.trim()
    company.contactEmail = document.getElementById('compContactEmail').value.trim()
    company.contactPhone = document.getElementById('compContactPhone').value.trim()
    company.defaultCommissionPct = parseFloat(document.getElementById('compCommPct').value) || 8.5
    company.defaultM2mPct = 70
    company.notes = document.getElementById('compNotes').value.trim()
    window.syncCompanyToSupabase(company)
    window.closeModal('newCompanyModal')
    renderEmpCompanies()
    populateEmpCompanyDropdowns()
    window.toast(`Empresa "${name}" ${editId ? 'actualizada' : 'creada'}`, 'success')
}

function renderEmpCompanies() {
    const { companies, companyBookings } = store
    const grid = document.getElementById('companiesGrid')
    if (!grid) return
    if (!companies.length) { grid.innerHTML = '<p style="color:var(--text-3);text-align:center;padding:40px;">No hay empresas registradas.</p>'; return }
    document.getElementById('badgeCompanies').textContent = companies.filter(c => c.active !== false).length
    grid.innerHTML = companies.filter(c => c.active !== false).map(c => {
        const bookings = companyBookings.filter(b => b.companyId === c.id)
        const totalPurchase = bookings.reduce((s, b) => s + (b.totalPurchase || 0), 0)
        const totalM2M = bookings.reduce((s, b) => s + (b.m2mAmount || 0), 0)
        const pending = bookings.filter(b => b.stage === 'pendiente' || b.stage === 'confirmado').length
        return `<div class="client-card" onclick="openEditCompany('${c.id}')" style="cursor:pointer;">
            <div class="client-header">
                <div class="client-avatar" style="background:linear-gradient(135deg,#F97316,#EAB308);">${c.name.charAt(0)}</div>
                <div class="client-info">
                    <div class="client-name">${c.name}</div>
                    <div class="client-phone">${c.contactName || ''} ${c.contactEmail ? '| ' + c.contactEmail : ''}</div>
                </div>
            </div>
            <div class="client-trips">
                <div class="trips-title">${bookings.length} reservas | Compras: ${window.fmtUSD(totalPurchase)} | M2M: ${window.fmtUSD(totalM2M)}</div>
                <div style="font-size:11px;color:var(--text-3);">Comisión: ${c.defaultCommissionPct}% | Pendientes: ${pending}</div>
            </div>
        </div>`
    }).join('')
}

// --- BOOKING CRUD ---
function openNewBookingModal() {
    const { companies } = store
    document.getElementById('bkEditId').value = ''
    document.getElementById('bkModalTitle').textContent = 'Nueva Reserva'
    const sel = document.getElementById('bkCompany')
    sel.innerHTML = '<option value="">Seleccionar...</option>' + companies.filter(c => c.active !== false).map(c => `<option value="${c.id}">${c.name}</option>`).join('')
    document.getElementById('bkStage').value = 'pendiente'
    ;['bkTraveler', 'bkResNum', 'bkHotel', 'bkDest', 'bkCheckIn', 'bkCheckOut', 'bkNotes'].forEach(id => document.getElementById(id).value = '')
    document.getElementById('bkGuests').value = '1'
    document.getElementById('bkRooms').value = '1'
    document.getElementById('bkTotal').value = ''
    document.getElementById('bkCommRate').value = '8.5'
    document.getElementById('bkCommAmt').value = ''
    document.getElementById('bkM2M').value = ''
    window.openModal('newBookingModal')
}

function onBkCompanyChange() {
    const { companies } = store
    const comp = companies.find(c => c.id === document.getElementById('bkCompany').value)
    if (comp) document.getElementById('bkCommRate').value = comp.defaultCommissionPct || 8.5
    calcBookingCommission()
}

function calcBookingCommission() {
    const total = parseFloat(document.getElementById('bkTotal').value) || 0
    const rate = parseFloat(document.getElementById('bkCommRate').value) || 0
    const commAmt = total * rate / 100
    const m2mAmt = commAmt * 0.70
    document.getElementById('bkCommAmt').value = commAmt.toFixed(2)
    document.getElementById('bkM2M').value = m2mAmt.toFixed(2)
}

function openBookingDetail(id) {
    const { companies, companyBookings } = store
    const b = companyBookings.find(bk => bk.id === id)
    if (!b) return
    document.getElementById('bkEditId').value = id
    document.getElementById('bkModalTitle').textContent = 'Editar Reserva'
    const sel = document.getElementById('bkCompany')
    sel.innerHTML = '<option value="">Seleccionar...</option>' + companies.filter(c => c.active !== false).map(c => `<option value="${c.id}">${c.name}</option>`).join('')
    sel.value = b.companyId || ''
    document.getElementById('bkStage').value = b.stage || 'pendiente'
    document.getElementById('bkTraveler').value = b.travelerName || ''
    document.getElementById('bkResNum').value = b.reservationNum || ''
    document.getElementById('bkHotel').value = b.hotelName || ''
    document.getElementById('bkDest').value = b.destination || ''
    document.getElementById('bkCheckIn').value = b.checkIn || ''
    document.getElementById('bkCheckOut').value = b.checkOut || ''
    document.getElementById('bkGuests').value = b.numGuests || 1
    document.getElementById('bkRooms').value = b.numRooms || 1
    document.getElementById('bkTotal').value = b.totalPurchase || ''
    document.getElementById('bkCommRate').value = b.commissionRate || 8.5
    document.getElementById('bkCommAmt').value = (b.commissionAmount || 0).toFixed(2)
    document.getElementById('bkM2M').value = (b.m2mAmount || 0).toFixed(2)
    document.getElementById('bkNotes').value = b.notes || ''
    window.openModal('newBookingModal')
}

function saveBooking() {
    const { companyBookings } = store
    const companyId = document.getElementById('bkCompany').value
    const traveler = document.getElementById('bkTraveler').value.trim()
    if (!companyId) { window.toast('Selecciona una empresa', 'error'); return }
    if (!traveler) { window.toast('Nombre del viajero requerido', 'error'); return }
    const editId = document.getElementById('bkEditId').value
    let booking
    if (editId) {
        booking = companyBookings.find(b => b.id === editId)
        if (!booking) return
    } else {
        booking = { id: 'bk_' + Date.now() }
        companyBookings.push(booking)
    }
    booking.companyId = companyId
    booking.stage = document.getElementById('bkStage').value
    booking.travelerName = traveler
    booking.reservationNum = document.getElementById('bkResNum').value.trim()
    booking.hotelName = document.getElementById('bkHotel').value.trim()
    booking.destination = document.getElementById('bkDest').value.trim()
    booking.checkIn = document.getElementById('bkCheckIn').value
    booking.checkOut = document.getElementById('bkCheckOut').value
    booking.numGuests = parseInt(document.getElementById('bkGuests').value) || 1
    booking.numRooms = parseInt(document.getElementById('bkRooms').value) || 1
    booking.totalPurchase = parseFloat(document.getElementById('bkTotal').value) || 0
    booking.commissionRate = parseFloat(document.getElementById('bkCommRate').value) || 8.5
    booking.commissionAmount = parseFloat(document.getElementById('bkCommAmt').value) || 0
    booking.m2mPct = 70
    booking.m2mAmount = parseFloat(document.getElementById('bkM2M').value) || 0
    booking.notes = document.getElementById('bkNotes').value.trim()
    window.syncBookingToSupabase(booking)
    window.closeModal('newBookingModal')
    renderEmpPipeline()
    window.toast(`Reserva de ${traveler} ${editId ? 'actualizada' : 'creada'}`, 'success')
}

// --- INVOICE VIEW ---
function getInvoiceFiltered() {
    const { companyBookings } = store
    let filtered = [...companyBookings]
    const compId = document.getElementById('invoiceCompany')?.value
    const month = document.getElementById('invoiceMonth')?.value
    const year = document.getElementById('invoiceYear')?.value
    if (compId) filtered = filtered.filter(b => b.companyId === compId)
    if (month || year) {
        filtered = filtered.filter(b => {
            if (!b.checkIn) return false
            const d = new Date(b.checkIn)
            if (month && (d.getMonth() + 1) !== parseInt(month)) return false
            if (year && d.getFullYear() !== parseInt(year)) return false
            return true
        })
    }
    return filtered
}

function renderInvoice() {
    const filtered = getInvoiceFiltered()
    const total = filtered.reduce((s, b) => s + (b.totalPurchase || 0), 0)
    const comm = filtered.reduce((s, b) => s + (b.commissionAmount || 0), 0)
    const m2m = filtered.reduce((s, b) => s + (b.m2mAmount || 0), 0)
    const el = id => document.getElementById(id)
    if (el('invStatBookings')) el('invStatBookings').textContent = filtered.length
    if (el('invStatTotal')) el('invStatTotal').textContent = window.fmtUSD(total)
    if (el('invStatComm')) el('invStatComm').textContent = window.fmtUSD(comm)
    if (el('invStatM2M')) el('invStatM2M').textContent = window.fmtUSD(m2m)

    const wrap = document.getElementById('invoiceTableWrap')
    if (!wrap) return
    if (!filtered.length) { wrap.innerHTML = '<p style="color:var(--text-3);text-align:center;padding:40px;">No hay reservas para este periodo.</p>'; return }

    wrap.innerHTML = `<table class="inv-table">
        <thead><tr>
            <th>Viajero</th><th>Hotel</th><th>Destino</th><th>Check-in</th><th style="text-align:right;">Compra</th>
            <th style="text-align:right;">Comisión</th><th style="text-align:right;">M2M</th><th style="text-align:center;">Estado</th>
        </tr></thead>
        <tbody>${filtered.map(b => {
            const stg = EMPRESAS_STAGES.find(s => s.id === b.stage)
            return `<tr>
                <td>${b.travelerName || '-'}</td>
                <td>${(b.hotelName || '-').substring(0, 25)}</td>
                <td>${b.destination || '-'}</td>
                <td>${b.checkIn ? new Date(b.checkIn + 'T12:00:00').toLocaleDateString('es-CO', { month: 'short', day: 'numeric', year: 'numeric' }) : '-'}</td>
                <td style="text-align:right;">${window.fmtUSD(b.totalPurchase)}</td>
                <td style="text-align:right;">${window.fmtUSD(b.commissionAmount)}</td>
                <td style="text-align:right;color:var(--green);">${window.fmtUSD(b.m2mAmount)}</td>
                <td style="text-align:center;"><span class="stage-pill" style="background:${stg?.color || '#888'}20;color:${stg?.color || '#888'};">${stg?.name || b.stage}</span></td>
            </tr>`
        }).join('')}</tbody>
        <tfoot><tr>
            <td colspan="4" style="font-weight:700;">TOTAL (${filtered.length} reservas)</td>
            <td style="text-align:right;">${window.fmtUSD(total)}</td>
            <td style="text-align:right;">${window.fmtUSD(comm)}</td>
            <td style="text-align:right;color:var(--green);">${window.fmtUSD(m2m)}</td>
            <td></td>
        </tr></tfoot>
    </table>`
}

function markAllConfirmadoAsFacturado() {
    const filtered = getInvoiceFiltered().filter(b => b.stage === 'confirmado')
    if (!filtered.length) { window.toast('No hay reservas confirmadas en este periodo', 'warning'); return }
    filtered.forEach(b => { b.stage = 'facturado'; window.supabaseDB.updateBookingStage(b.id, 'facturado') })
    renderInvoice()
    renderEmpPipeline()
    window.toast(`${filtered.length} reservas marcadas como Facturado`, 'success')
}

function exportInvoiceExcel() {
    const filtered = getInvoiceFiltered()
    if (!filtered.length) { window.toast('No hay datos para exportar', 'warning'); return }
    exportBookingsToExcel(filtered, 'Factura')
}

function exportBookingsToExcel(bookings, label) {
    const { companies } = store
    const wb = XLSX.utils.book_new()
    const data = bookings.map(b => {
        const comp = companies.find(c => c.id === b.companyId)
        const stg = EMPRESAS_STAGES.find(s => s.id === b.stage)
        return {
            'Empresa': comp?.name || '',
            'Viajero': b.travelerName || '',
            'Hotel': b.hotelName || '',
            'Destino': b.destination || '',
            'Check-in': b.checkIn || '',
            'Check-out': b.checkOut || '',
            'Huéspedes': b.numGuests || 1,
            'Habitaciones': b.numRooms || 1,
            'Total Compra': b.totalPurchase || 0,
            'Comisión %': b.commissionRate || '',
            'Comisión USD': b.commissionAmount || 0,
            'M2M (70%)': b.m2mAmount || 0,
            '# Reserva': b.reservationNum || '',
            'Estado': stg?.name || b.stage,
            'Notas': b.notes || ''
        }
    })
    const ws = XLSX.utils.json_to_sheet(data)
    XLSX.utils.book_append_sheet(wb, ws, 'Reservas')
    const filename = `Thunder_Staffing_${label}_${new Date().toISOString().split('T')[0]}.xlsx`
    XLSX.writeFile(wb, filename)
    window.toast('Excel exportado', 'success')
}

Object.assign(window, {
    switchCrmMode,
    populateEmpCompanyDropdowns,
    getFilteredBookings,
    resetEmpFilters,
    populateEmpYearFilters,
    renderEmpPipeline,
    renderBookingCard,
    setupEmpDragDrop,
    updateEmpStats,
    toggleEmpSelectMode,
    setupEmpSelectionMode,
    setupEmpDragSelection,
    startEmpDragSelection,
    updateEmpDragSelection,
    endEmpDragSelection,
    selectAllEmpVisible,
    selectEmpColumn,
    toggleEmpBooking,
    updateEmpSelectionCount,
    cancelEmpSelection,
    empBulkSetStage,
    empExportSelected,
    openNewCompanyModal,
    openEditCompany,
    saveCompany,
    renderEmpCompanies,
    openNewBookingModal,
    onBkCompanyChange,
    calcBookingCommission,
    openBookingDetail,
    saveBooking,
    getInvoiceFiltered,
    renderInvoice,
    markAllConfirmadoAsFacturado,
    exportInvoiceExcel,
    exportBookingsToExcel
})
